module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagei",
      "title": "i"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageii",
      "title": "ii"
    }
  })]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageiii",
      "title": "iii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tp1"
  }, [_vm._v("EXPLORATIONS IN "), _c('br'), _vm._v("ASIAN CHRISTIANITY")]), _vm._v(" "), _c('p', {
    staticClass: "tp2"
  }, [_vm._v("History, Theology, "), _c('br'), _vm._v("and Mission")]), _vm._v(" "), _c('p', {
    staticClass: "tp3"
  }, [_vm._v("SCOTT W. SUNQUIST")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "http://www.IVPacademic.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "IVP Academic Imprint",
      "src": "Images/IVPAcademic.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b481e56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02titlepage.vue
// module id = 57
// module chunks = 0